<template>
  <article class="identity-wrapper">
    <div class="container">
      <p class="text0">CARROT Core Value & Identity</p>
      <p class="text1">
        우리는 오직 우리의 존재 이유와 궁극적인 목표를 향해 나아갑니다.
      </p>
      <ul>
        <li>
          <img
            src="@/assets/img/newGlobal/introduce/main/identity/img00.png"
            alt="icon"
          />
          <p>철학 및 비젼</p>
          <p>CARROT만의 철학과 비젼</p>
          <p @click="goPage('/Philosophy#carrotIdentity')">more</p>
        </li>
        <li>
          <img
            src="@/assets/img/newGlobal/introduce/main/identity/img01.png"
            alt="icon"
          />
          <p>핵심가치</p>
          <p>1 Spirit! 1 Goal! 1 Team!</p>
          <p @click="goPage('/Philosophy#carrotCoreValue')">more</p>
        </li>
        <li>
          <img
            src="@/assets/img/newGlobal/introduce/main/identity/img02.png"
            alt="icon"
          />
          <p>수평문화</p>
          <p>수평조직문화를 위한 핵심요소</p>
          <p @click="goPage('/Philosophy#philHorizon')">more</p>
        </li>
        <li>
          <img
            src="@/assets/img/newGlobal/introduce/main/identity/img03.png"
            alt="icon"
          />
          <p>인재상</p>
          <p>스스로 학습하는 자연성 인간!</p>
          <p @click="goPage('/Philosophy#philPerson')">more</p>
        </li>
      </ul>
    </div>
  </article>
</template>
<script>
export default {
  name: "Identity",
  methods: {
    goPage(path) {
      location.href = path;
    },
  },
};
</script>
<style lang="scss" scoped>
.identity-wrapper {
  padding: 40px 0;

  @media screen and (min-width: 1350px) {
    padding: 80px 0;
  }

  .text0 {
    font-size: 33px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 24px;

    @media screen and (min-width: 1350px) {
      font-size: 50px;
      margin-bottom: 40px;
    }
  }

  .text1 {
    font-size: 15px;
    margin-bottom: 30px;
    text-align: center;

    @media screen and (min-width: 1350px) {
      font-size: 24px;
      margin-bottom: 100px;
    }
  }

  ul {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 40px 10px;

    @media screen and (min-width: 1350px) {
      grid-template-columns: repeat(4, 1fr);
    }

    li {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 10px;
      text-align: center;

      img {
        max-width: 138px;
      }

      p {
        &:nth-of-type(1) {
          font-size: 20px;
          font-weight: 700;

          @media screen and (min-width: 1350px) {
            font-size: 25px;
          }
        }

        &:nth-of-type(3) {
          font-size: 14px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
